import Vue from 'vue'
import App from './App.vue'
import VueRouter from "vue-router";
import VueResource from 'vue-resource';
//
// //开启debug模式
// Vue.config.debug = true;
Vue.use(VueRouter);
Vue.use(VueResource);
//引入公共css
require("./theme.scss");
// 引入组件
import article from './component/articleList.vue'
import baseRouter from './component/baseRouter.vue'
import firstComponent from './component/firstComponent.vue'
import secondComponent from './component/secondComponent.vue'
import doubanTop250 from './component/doubanTop250.vue'
// 部署路由
const router = new VueRouter({
    //mode: 'history',
    base: __dirname,
    routes: [
        {
            path:'/',
            redirect:'/home'
        },
        {
            path: '/home',
            component: article
        },
        {
            path:'/baseRouter',
            redirect:'/baseRouter/first',
            component:baseRouter,
            children: [
               {path: 'first',component: firstComponent},
               {path: 'second',component: secondComponent}
           ]

        },
        // {
        //     path: '/baseRouter/first',
        //     component: firstComponent
        // },
        // {
        //     path: '/baseRouter/second',
        //     component: secondComponent
        // },
        {
            path: '/doubanTop250',
            component: doubanTop250
        },
    ]
})

const vm = new Vue({
    el: '#app',
    router: router,
    render: h => h(App),
    // router监听.
    // watch: {
    //     '$route' (to, from) {
    //       console.log(to)
    //     }
    // }
})



// WEBPACK FOOTER //
// ./src/main.js